import $ from "jquery";

$(document).ready(function () {
    $('.item_header, .item_content, .product_info').on('click', function () {
        $(this).parent().find('.link_to_product').click();
    });
});